/**
 * Update date: 2025-01-06
 * Screen 2087.D
 */
import { NotFoundPage } from 'app/components/NotFoundPage';
import LoadPanel from 'app/components/LoadPanel';
import React, { useState, useContext, createContext } from 'react';

const List = React.lazy(() => import('./List'));
/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2087_D_Web_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const M2087_D_Web = () => {
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    data: null,
  });

  const value: any = {
    setData,
    data,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
};

export default M2087_D_Web;
